/*=============================================== ButtonGroupPage ===============================================*/

import { ButtonGroup } from "tsx-library-julseb"
import type { ButtonGroupProps } from "tsx-library-julseb/types"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps, propAllLinks } from "data"

const ButtonGroupPage = () => {
    const buttons: ButtonGroupProps[] = [
        {
            iconOnly: "arrow-left",
            onClick: () => alert("Clicked"),
        },
        {
            text: "Button",
            onClick: () => alert("Clicked"),
        },
        {
            text: "Button",
            onClick: () => alert("Clicked"),
        },
        {
            text: "Link",
            href: "http://google.com",
            blank: true,
        },
        {
            text: "Router Link",
            to: "/",
        },
        {
            iconOnly: "arrow-right",
            to: "/",
        },
    ]

    const items: ItemType[] = [
        {
            title: "Plain",
            content: <ButtonGroup buttons={buttons} color="secondary" />,
            code: 'const buttons = [\n    {\n        iconOnly: "arrow-left",\n        onClick: () => alert("Clicked"),\n    },\n    {\n        text: "Button",\n        onClick: () => alert("Clicked"),\n    },\n    {\n        text: "Button",\n        onClick: () => alert("Clicked"),\n    },\n    {\n        text: "Link",\n        href: "http://google.com",\n        blank: true,\n    },\n    {\n        text: "Router Link",\n        to: "/",\n    },\n    {\n        iconOnly: "arrow-right",\n        to: "/",\n    },\n]\n\n<ButtonGroup buttons={buttons} color="secondary" />',
            codeTs: 'const buttons: ButtonGroupProps[] = [\n    {\n        iconOnly: "arrow-left",\n        onClick: () => alert("Clicked"),\n    },\n    {\n        text: "Button",\n        onClick: () => alert("Clicked"),\n    },\n    {\n        text: "Button",\n        onClick: () => alert("Clicked"),\n    },\n    {\n        text: "Link",\n        href: "http://google.com",\n        blank: true,\n    },\n    {\n        text: "Router Link",\n        to: "/",\n    },\n    {\n        iconOnly: "arrow-right",\n        to: "/",\n    },\n]\n\n<ButtonGroup buttons={buttons} color="secondary" />',
        },
        {
            title: "Transparent",
            content: <ButtonGroup buttons={buttons} variant="transparent" />,
            code: 'const buttons = [\n    {\n        iconOnly: "arrow-left",\n        onClick: () => alert("Clicked"),\n    },\n    {\n        text: "Button",\n        onClick: () => alert("Clicked"),\n    },\n    {\n        text: "Button",\n        onClick: () => alert("Clicked"),\n    },\n    {\n        text: "Link",\n        href: "http://google.com",\n        blank: true,\n    },\n    {\n        text: "Router Link",\n        to: "/",\n    },\n    {\n        iconOnly: "arrow-right",\n        to: "/",\n    },\n]\n\n<ButtonGroup buttons={buttons} variant="transparent" />',
            codeTs: 'const buttons: ButtonGroupProps[] = [\n    {\n        iconOnly: "arrow-left",\n        onClick: () => alert("Clicked"),\n    },\n    {\n        text: "Button",\n        onClick: () => alert("Clicked"),\n    },\n    {\n        text: "Button",\n        onClick: () => alert("Clicked"),\n    },\n    {\n        text: "Link",\n        href: "http://google.com",\n        blank: true,\n    },\n    {\n        text: "Router Link",\n        to: "/",\n    },\n    {\n        iconOnly: "arrow-right",\n        to: "/",\n    },\n]\n\n<ButtonGroup buttons={buttons} variant="transparent" />',
        },
        {
            title: "Ghost",
            content: <ButtonGroup buttons={buttons} variant="ghost" />,
            code: 'const buttons = [\n    {\n        iconOnly: "arrow-left",\n        onClick: () => alert("Clicked"),\n    },\n    {\n        text: "Button",\n        onClick: () => alert("Clicked"),\n    },\n    {\n        text: "Button",\n        onClick: () => alert("Clicked"),\n    },\n    {\n        text: "Link",\n        href: "http://google.com",\n        blank: true,\n    },\n    {\n        text: "Router Link",\n        to: "/",\n    },\n    {\n        iconOnly: "arrow-right",\n        to: "/",\n    },\n]\n\n<ButtonGroup buttons={buttons} variant="ghost" />',
            codeTs: 'const buttons: ButtonGroupProps[] = [\n    {\n        iconOnly: "arrow-left",\n        onClick: () => alert("Clicked"),\n    },\n    {\n        text: "Button",\n        onClick: () => alert("Clicked"),\n    },\n    {\n        text: "Button",\n        onClick: () => alert("Clicked"),\n    },\n    {\n        text: "Link",\n        href: "http://google.com",\n        blank: true,\n    },\n    {\n        text: "Router Link",\n        to: "/",\n    },\n    {\n        iconOnly: "arrow-right",\n        to: "/",\n    },\n]\n\n<ButtonGroup buttons={buttons} variant="ghost" />',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "variant",
            type: "string",
            possible: ["plain", "transparent", "ghost"],
            default: "plain",
        },
        {
            subtitle: "color",
            type: "string",
            possible: commonProps.colorsHover,
            default: "primary",
        },
        {
            subtitle: "buttonsSize",
            type: "string",
            possible: ["default", "small"],
            default: "default",
        },
        "separator",
        {
            subtitle: "buttons",
            type: "array of objects",
            required: true,
        },
        {
            title: (
                <>
                    <code>button</code> object
                </>
            ),
            subtitle: "onClick",
            intro: (
                <>
                    Either <code>onClick</code>, <code>to</code> or{" "}
                    <code>href</code> are required.
                </>
            ),
            type: "function",
        },
        ...propAllLinks,
        {
            subtitle: "text",
            intro: (
                <>
                    Either <code>text</code> or <code>iconOnly</code> are
                    required.
                </>
            ),
            type: "string",
        },
        {
            subtitle: "aria-label",
            type: "string",
        },
        {
            subtitle: "iconOnly",
            intro: commonProps.addIconCapital,
            type: "string",
        },
        {
            subtitle: "iconLeft",
            type: "string",
        },
        {
            subtitle: "iconRight",
            type: "string",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default ButtonGroupPage
